import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { HandheldEntity, HandheldDetails, HandheldCreate, HandheldUpdate } from '../models';
import { getFieldToUpdateModel } from '../adapters';

@Injectable({
  providedIn: 'root',
})
export class HandheldApiService extends BaseApi<HandheldEntity> {
  constructor() {
    super('', {
      get: '/Handheld/admin/GetHandHeldList'
    });
  }

  getDetails(id: number) {
    return http$.get<HandheldDetails>(`/Handheld/admin/GetHandHeld?Id=${id}`);
  }

  createHandheld(model: HandheldCreate) {
    return http$.post('/Handheld/admin/CreateHandheld', model);
  }

  updateHandheld(id: number, model: HandheldUpdate) {
    return http$.put('/Handheld/admin/UpdateHandheld', { id, editHandheldDTO: getFieldToUpdateModel(model) });
  }

  deleteUser(id: number) {
    return http$.delete('/Handheld/admin/DeleteUpdateHand', { body: { id } });
  }
}
